import axios from "axios";

import { AirtableRecordResponse } from "../types";

import { AIRTABLE_HEADERS, AIRTABLE_URL } from "@/constants/api";

/**
 * Returns a single record from Airtable
 *
 * @remarks
 * API reference: https://airtable.com/developers/web/api/get-record
 *
 * @param identifer - string containing tableId and recordId,
 *                    should follow pattern `${tableId}/${recordId}`
 * @returns Promise that resolves to an Airtable record
 *
 * @example
 * ```typescript
 * // Fetch by identifier (using AirtableTableId enum)
 * fetchAirtableRecord(`${AirtableTableId.Collections}/${id}`)
 *
 * // Fetch by identifier (using explicit tableId and recordId)
 * fetchAirtableRecord("tbl68wML9cjMrq9i7/recswLnQrdLWpejsl")
 * ```
 *
 * @throws Will throw an error if the network request fails
 */
export const fetchAirtableRecord = async (
  identifier: string,
): Promise<AirtableRecordResponse> => {
  const url = `${AIRTABLE_URL}${identifier}`;

  return axios
    .get(url, { headers: AIRTABLE_HEADERS })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      console.error(`Error fetching Record ${identifier} from Airtable`, error);
    });
};
